"use strict";

import "core-js/modules/web.dom-collections.iterator.js";
import { RemixPage } from "~/utils/remix-page";
import { cssLinks } from "@ttark/css-links";
import { PoiHead } from "./head";
import { PoiBody } from "./body";
import { buildMasterLoader } from "~/utils/build-master-loader";
var links = () => [...cssLinks("routes/poi.$poi_id")];
var loader = buildMasterLoader("poi");
var PoiPage = class extends RemixPage {
  constructor() {
    super(...arguments);
    this.Head = PoiHead;
    this.Body = PoiBody;
  }
};
export { PoiPage as default, links };